/* 0.49.71 - Country dial codes for the phone formulas (phonecode,
 * phonelocal), filled when a page with a Phone field loads its country
 * list (the same list the phone picker uses). */
let codes = [];

export function setDialCodes(countries) {
  const set = new Set();
  for (const c of Array.isArray(countries) ? countries : []) {
    const d = String((c && c.dial_code) || '').replace(/\D/g, '');
    if (d) set.add(d);
  }
  codes = [...set].sort((a, b) => b.length - a.length);
}

const digitsOf = (v) => String(v == null ? '' : v).replace(/\D/g, '');

/** { code, local } of a phone written "+37491010364" (or with spaces,
 *  dashes, brackets). The code is the longest dial code it starts with. */
export function splitPhone(value) {
  const s = String(value == null ? '' : value).trim();
  const d = digitsOf(s);
  if (!d) return { code: '', local: '' };
  if (!s.startsWith('+') && !s.startsWith('00')) return { code: '', local: d };
  const all = s.startsWith('00') ? d.slice(2) : d;
  const code = codes.find(c => all.startsWith(c)) || '';
  return { code, local: code ? all.slice(code.length) : all };
}

/** The local digits laid into a pattern: "##-###-###" and 91010364 give
 *  91-010-364. Digits beyond the pattern are added at the end, and the
 *  pattern stops where the digits do. */
export function layDigits(digits, pattern) {
  const d = digitsOf(digits);
  if (!pattern) return d;
  let out = '';
  let i = 0;
  for (const ch of String(pattern)) {
    if (i >= d.length) break;
    if (ch === '#') { out += d[i]; i += 1; } else out += ch;
  }
  return out + d.slice(i);
}

export { digitsOf };
